export enum DirSyncStatuses {
    Pending = 0,
    Created = 1,
    Provisioned = 2,
    Active = 3,
    Disabled = 4,
    Archived = 5
}
